import { render, staticRenderFns } from "./PointCollection.vue?vue&type=template&id=9cda34d0"
import script from "./PointCollection.vue?vue&type=script&lang=js"
export * from "./PointCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports